import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.#initAnimations()
  }

  #initAnimations() {
    const intersectionHandler = (entries, observer) => {
      entries.forEach(entry => {
        const threshold = parseFloat(entry.target.getAttribute('data-threshold'))
        if (entry.intersectionRatio > threshold) {
          entry.target.classList.remove('animation--start')
          observer.unobserve(entry.target)
        }
      })
    }

    const observer = new IntersectionObserver(intersectionHandler, {
      threshold: Array.from({ length: 11 }, (_, i) => i * 0.1)
    })

    const elements = document.querySelectorAll('[data-controller="animate-on-entering-viewport"]')
    elements.forEach(element => {
      element.classList.add('animation--start')
      observer.observe(element)
    })

  }
}
